// extracted by mini-css-extract-plugin
export default {"expandInfo":"FormularioFicha_expandInfo__gk6SK","btnSemIndex":"FormularioFicha_btnSemIndex__B72cp"};